import React, { useState, useEffect, useRef } from "react";
import { Platform } from "react-native";
import Typography from "../Typography";
import Button from "../OldButton";
import Box from "../Box";
import Stack from "../Stack";
import Spacer from "../Spacer";

export type CaptureData = {
  uri: string;
  dataUri: string;
  width: number;
  height: number;
};

interface PropTypes {
  cameraComponent: any;
  onCapture: (data: CaptureData) => void;
  onFailed?: () => void;
  flashMode?: React.ReactNode;
}

function CameraView(props: PropTypes) {
  let { cameraComponent: Camera } = props;
  let [_hasPermission, setHasPermission] = useState<boolean | null>(null);
  let [capturing, setCapturing] = useState(false);
  let cameraRef = useRef(null);
  let [flashMode, setFlashMode] = useState("off");

  useEffect(() => {
    async function requestPermission() {
      const { status } = await Camera.requestPermissionsAsync();
      setHasPermission(status === "granted");
    }

    if (Platform.OS !== "web") {
      requestPermission();
    } else {
      setHasPermission(true);
    }

    (async () => {
      // @ts-ignore farzad will fix
      let camera: any = cameraRef.current;
      if (camera) {
        await camera.getAvailablePictureSizesAsync("4:3");
      }
    })();
  }, []);

  // if (hasPermission === null) {
  //   return <View />;
  // }
  // if (hasPermission === false) {
  //   return <Text>No access to camera</Text>;
  // }

  return (
    <Box style={{ flex: 1 }}>
      <Camera
        autoFocus="off"
        style={{ flex: 1 }}
        pictureSize="640x480"
        type={"back"}
        ref={cameraRef}
        flashMode={flashMode}
      >
        {props.flashMode ? (
          <Stack alignment="start" direction="vertical">
            <Box p="l">
              <Button
                size="l"
                type="circle-like"
                bg="common.white"
                disabled={capturing}
                onPress={() =>
                  setFlashMode(flashMode == "torch" ? "off" : "torch")
                }
              >
                {props.flashMode(flashMode)}
              </Button>
            </Box>
          </Stack>
        ) : null}
        <Box
          pb="xxxl"
          style={{
            flex: 1,
            flexDirection: "column-reverse",
            alignItems: "center",
          }}
        >
          <Button
            onPress={async () => {
              let camera = cameraRef.current;
              if (camera) {
                setCapturing(true);
                try {
                  // @ts-ignore
                  let data = await camera.takePictureAsync({
                    base64: true,
                    // quality: 0.5,

                    // IMPORTANT: Some android devices will crash
                    skipProcessing: true,
                  });

                  let dataUri;
                  if (Platform.OS === "web") {
                    dataUri = data.base64;
                  } else {
                    dataUri = `data:image/jpg;base64,${data.base64}`;
                  }

                  let output = {
                    uri: data.uri,
                    dataUri,
                    width: data.width,
                    height: data.height,
                  };

                  props.onCapture(output);
                } catch {
                  if (props.onFailed) {
                    props.onFailed();
                  }
                } finally {
                  setCapturing(false);
                }
              }
            }}
            size="l"
            type="circle-like"
            bg="green.main"
            disabled={capturing}
          >
            <Typography color="common.white" aligment="center">
              ثبــــت عـــکس
            </Typography>
          </Button>
        </Box>
      </Camera>
    </Box>
  );
}

export default CameraView;
